import View from '../../View'
import {connect} from '../../redux/utils'
import {bindActionCreators} from 'redux'
import {getSelectedTaskIdsArray, isNeedToLoadExistingTaskIds, isTasksLoaded} from './selectors'
import {cleanupExistingTaskIds, cleanupNonExistingSelectedIds, cleanupSelectionsData, loadExistingTaskIdsAction} from './actions'
import {getSingleCPSelection, getViewMode, isNeedToShowSelection} from '../common/selectors'

class SelectionController extends View {
    constructor({
        loadExistingTaskIdsAction = () => {},
        cleanupSelectionsDataAction = () => {},
        cleanupExistingTaskIdsAction = () => {},
        cleanupNonExistingSelectedIdsAction = () => {},
    }) {
        super(null)

        this.state = {
            selectedTaskIdsArray: [],
            needToLoadExistingIds: false,

            singleCPSelection: {},
            selectionAvailable: false,

            viewMode: null,
            tasksLoaded: false,
        }

        this.actions = {
            loadExistingTaskIdsAction,
            cleanupSelectionsDataAction,
            cleanupExistingTaskIdsAction,
            cleanupNonExistingSelectedIdsAction,
        }

        this.onStatePropertyBecameTrue('needToLoadExistingIds', () => {
            this.actions.loadExistingTaskIdsAction()
        })

        this.onStatePropertyChanged('selectedTaskIdsArray', (selectedIds, prevSelected) => {
            const prevSelectedTasksCount = prevSelected ? prevSelected.length : 0
            const selectedTasksCount = selectedIds.length

            if (prevSelectedTasksCount !== selectedTasksCount && selectedTasksCount === 0) {
                this.actions.cleanupSelectionsDataAction()
            }
        })

        // clear selection if filters changed
        this.onStatePropertyDeeplyChanged('singleCPSelection', (currentSelection, prevSelection = {
            projectId: null,
            customerId: null,
        }) => {
            const {projectId} = currentSelection
            const prevProjectId = prevSelection.projectId

            if (prevProjectId != null && projectId !== null && prevProjectId !== projectId) {
                this.actions.cleanupSelectionsDataAction()
            }
        })

        this.onStatePropertyBecameValue('selectionAvailable', false, () => {
            this.actions.cleanupSelectionsDataAction()
        })

        this.onStatePropertyBecameTrue('tasksLoaded', () => {
            // when data loaded need to sync selected ids with actual loaded
            // it's add usability when filters changed (search/statuses) or if sorting changed - no need reselect tasks
            // for case if there are problems - possible to replace by `cleanupSelectionsDataAction`
            this.actions.cleanupExistingTaskIdsAction()
        })

        this.onStatePropertyChanged('viewMode', () => {
            // update selected ids with current existing (may be differ). only if tab already loaded
            if (this.state.tasksLoaded) {
                this.actions.cleanupNonExistingSelectedIdsAction()
            }
        })
    }
}

export default connect(
    (state) => ({
        selectedTaskIdsArray: getSelectedTaskIdsArray(state),
        needToLoadExistingIds: isNeedToLoadExistingTaskIds(state),
        tasksLoaded: isTasksLoaded(state),
        singleCPSelection: getSingleCPSelection(state),
        selectionAvailable: isNeedToShowSelection(state),
        viewMode: getViewMode(state),
    }),
    (dispatch) => ({
        loadExistingTaskIdsAction: bindActionCreators(loadExistingTaskIdsAction, dispatch),
        cleanupSelectionsDataAction: bindActionCreators(cleanupSelectionsData, dispatch),
        cleanupExistingTaskIdsAction: bindActionCreators(cleanupExistingTaskIds, dispatch),
        cleanupNonExistingSelectedIdsAction: bindActionCreators(cleanupNonExistingSelectedIds, dispatch),
    })
)(SelectionController)



// WEBPACK FOOTER //
// ./web/js/taskManagement/taskSelection/SelectionController.js